import { ApprovalLogItemType } from 'generated/types'
import { ChatBubble } from './styles'
import { Tag } from 'antd'
import { AkaTypography } from '../../../components'
import { StylesDictionary } from 'components/typography/styles'
import { useTranslation } from 'react-i18next'

const styles: StylesDictionary = {
	chatMessage: {
		lineHeight: '1.2em',
		marginTop: '1em',
		whiteSpace: 'pre-line'
	}
}

export type ApprovalFeedItem = Pick<
	ApprovalLogItemType,
	| 'isUserMessage'
	| 'actionMessage'
	| 'userMessage'
	| 'createdAt'
	| 'approvalRun'
	| 'createdByText'
	| 'attachment'
>

export const ApprovalFeedItem = ({
	createdByText,
	createdAt,
	approvalRun,
	actionMessage,
	userMessage,
	attachment,
	isUserMessage
}: ApprovalFeedItem) => {
	const [t] = useTranslation()
	return (
		<ChatBubble direction={isUserMessage ? 'right' : 'left'}>
			<div style={{ display: 'flex', gap: '0.25rem', flexWrap: 'wrap' }}>
				<Tag
					color={approvalRun.tenant.hexColor}
					style={{ borderRadius: '0.5rem' }}
				>
					{approvalRun.tenant.catalogName}
				</Tag>
				{approvalRun.catalogType && (
					<Tag color="default" style={{ borderRadius: '0.5rem' }}>
						{approvalRun.catalogType.displayTitle ||
							approvalRun.catalogType.code}
					</Tag>
				)}
			</div>
			<AkaTypography variant={'bodySegoe'} style={styles.chatMessage}>
				{actionMessage}
			</AkaTypography>
			{userMessage && (
				<AkaTypography variant={'tiny'} style={styles.chatMessage}>
					{userMessage}
				</AkaTypography>
			)}
			{attachment && (
				<AkaTypography variant={'tiny'}>
					<a href={attachment} target="_blank" rel="noopener noreferrer">
						{t('approval.approvalList.messageModal.attachmentDownload')}
					</a>
				</AkaTypography>
			)}
			<AkaTypography variant={'tiny'} gutterbottom={0} color={'secondary'}>
				<>
					{createdByText},{' '}
					{new Date(createdAt).toLocaleString('de', {
						year: 'numeric',
						month: 'numeric',
						day: 'numeric',
						hour: '2-digit',
						minute: '2-digit'
					})}
				</>
			</AkaTypography>
		</ChatBubble>
	)
}
